import {Component, inject, input, OnInit, output} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {NgClass, NgOptimizedImage} from "@angular/common";
import {AccountService} from "../../services/account/account.service";
import {MatDialog} from "@angular/material/dialog";
import {openLogoutDialog} from "../../components/logout-dialog/logout-dialog.component";

@Component({
    selector: 'app-cabinet-menu-list',
    imports: [
        TranslateModule,
        RouterLink,
        RouterLinkActive,
        NgOptimizedImage,
        NgClass
    ],
    templateUrl: './cabinet-menu-list.component.html',
    styles: `
      .cabinet-menu {
        grid-template-columns: repeat(6, minmax(0, 1fr));
      }

      .cabinet-menu__item__link,
      .cabinet-menu__item__button {
        min-width: 0;
        white-space: nowrap;
        font-size: clamp(0.78rem, 0.83vw, 1rem);
      }

      .cabinet-menu__item__link,
      .cabinet-menu__item__button span {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      @media screen and (max-width: 992px) {
        .cabinet-menu {
          grid-template-columns: none;
        }

        .cabinet-menu__item__link,
        .cabinet-menu__item__button {
          font-size: 0.75rem;
        }
      }
    `
})
export class CabinetMenuListComponent implements OnInit {
  // menuList = signal<TCabinetMenu[]>([]);
  show = input.required<boolean>();
  onCloseMenu = output<void>();
  accountService = inject(AccountService);
  #dialog = inject(MatDialog);

  ngOnInit(): void {

  }
  
  async showLogoutDialog() {
    const action = await openLogoutDialog(this.#dialog);

    if (!action) {
      return;
    }

    await this.logout();
  }

  async logout(): Promise<void> {
    await this.accountService.logout('exit');
  }

  closeMenu(): void {
    this.onCloseMenu.emit();
  }
}
